import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

/**
 * The standard primary submit button: "Save" at rest, and a spinner beside
 * "Saving" while the request is in flight. Disabled while saving so repeated
 * clicks cannot fire a second submit.
 *
 * Pass `children` to override the resting label where the action is not a save
 * ("Create table", "Add field"); the in-flight label stays "Saving" unless
 * `savingText` overrides it too.
 */
function SaveButton({
  saving = false,
  disabled = false,
  savingText = "Saving",
  children = "Save",
  ...props
}) {
  return (
    <Button disabled={disabled || saving} {...props}>
      {saving && <Spinner data-icon="inline-start" />}
      {saving ? savingText : children}
    </Button>
  );
}

export { SaveButton };
